import { useStaticQuery, graphql } from 'gatsby'

export function useDataCompanyNumbersByEn() {
    const data = useStaticQuery(graphql`
        {
            sectionTitle: datoCmsRenshinPageAbout(title: { eq: "Numbers: Title" }, locale: { eq: "en" }) {
                value
            }

            investmentsTitle: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 1, title" }, locale: { eq: "en" }) {
                value
            }

            investmentsText: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 1, text" }, locale: { eq: "en" }) {
                value
            }

            investmentsItemTitle_1: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 2, title" }, locale: { eq: "en" }) {
                value
            }

            investmentsItemText_1: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 2, text" }, locale: { eq: "en" }) {
                value
            }

            investmentsItemTitle_2: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 3, title" }, locale: { eq: "en" }) {
                value
            }

            investmentsItemText_2: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 3, text" }, locale: { eq: "en" }) {
                value
            }

            apartmentsTitle: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 4, title" }, locale: { eq: "en" }) {
                value
            }

            apartmentsText: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 4, text" }, locale: { eq: "en" }) {
                value
            }

            apartmentsItemTitle_1: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 5, title" }, locale: { eq: "en" }) {
                value
            }

            apartmentsItemText_1: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 5, text" }, locale: { eq: "en" }) {
                value
            }

            apartmentsItemTitle_2: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 6, title" }, locale: { eq: "en" }) {
                value
            }

            apartmentsItemText_2: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 6, text" }, locale: { eq: "en" }) {
                value
            }

            apartmentsItemTitle_3: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 7, title" }, locale: { eq: "en" }) {
                value
            }

            apartmentsItemText_3: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 7, text" }, locale: { eq: "en" }) {
                value
            }

            apartmentsItemTitle_4: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 8, title" }, locale: { eq: "en" }) {
                value
            }

            apartmentsItemText_4: datoCmsRenshinPageAbout(title: { eq: "Numbers: Block 8, text" }, locale: { eq: "en" }) {
                value
            }
        }
    `)

    return data
}
